import { useDisclosure } from "@chakra-ui/react";
import { fetchDataSources } from "../../services/state/administration/administration-async-calls";
import { AppDispatch, RootState } from "@/services/state/store";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

export const useAdministration = () => {
  const dispatch: AppDispatch = useDispatch();

  const {
    isOpen: isAddDataSourceOpen,
    onOpen: onAddDataSourceOpen,
    onClose: onAddDataSourceClose,
  } = useDisclosure();

  const dataSources = useSelector(
    (state: RootState) => state.administration.dataSources
  );

  useEffect(() => {
    dispatch(fetchDataSources());
  }, []);

  const columns = [
    {
      Header: "S.no",
      accessor: "sno",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Database",
      accessor: "database",
    },
    {
      Header: "Connection",
      accessor: "connection",
    },
    {
      Header: "Updated On",
      accessor: "updatedOn",
    },
  ];

  const data = dataSources.map((source, index) => ({
    sno: index + 1,
    name: source.dbSourceNm,
    database: "MySQL",
    connection: source.dbConnString,
    updatedOn: new Date(source.updatedOn || source.createdOn).toLocaleString(),
  }));
  return {
    columns,
    data,
    isAddDataSourceOpen,
    onAddDataSourceOpen,
    onAddDataSourceClose,
  };
};
